import { Paper, Popper } from "@mui/material";

interface DayTooltipProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  children: React.ReactNode;
}

export default function DayTooltip({ open, anchorEl, children }: DayTooltipProps) {
  return (
    <Popper open={open} anchorEl={anchorEl} placement="top" style={{ zIndex: 9999 }}>
      <Paper
        sx={{
          px: 1,
          py: 0.5,
          mb: 0.5,
          bgcolor: "grey.800",
          color: "white",
          fontSize: "0.75rem",
        }}
      >
        {children}
      </Paper>
    </Popper>
  );
}
